import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'
import WidgetContainer from './WidgetContainer'
import { MixHelper } from '../Utils/Mix'
import Axios from 'axios'
import styled from 'styled-components'

Wix.Utils.getInstance = function () {
    var url = window.location;
    var instanceRegexp = /.*instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#).*/g;
    var instance = instanceRegexp.exec(url);
    if (instance && instance[1]) {
        return instance[1];
    } else {
        return undefined;
    }
};

MixHelper.initializeMix()


window.addEventListener('error', async (e) => {
    // console.log('error window event', e)
    if (e.error) {
        try {
            const response = await Axios.get(`/errorCatch?compId=${Wix.Utils.getCompId()}&instance=${Wix.Utils.getInstance()}&sourceWindow=widget&errorLocation=${JSON.stringify({ line: e.lineno, column: e.colno })}`)
            // console.log(response)
            MixHelper.events.errorCatched(e.error, response.data)
        } catch (e) {
            console.log('first error catch', e)
        }
    }
})

window.addEventListener('unhandledrejection', async (e) => {
    // console.log('unhandledrejection window event', e)
    // if (e.reason) {
    //     try {
    //         const response = await Axios.get(`/errorCatch?compId=${Wix.Utils.getCompId()}&instance=${Wix.Utils.getInstance()}&sourceWindow=widget&errorLocation=${JSON.stringify({ line: e.lineno, column: e.colno })}`)
    //         // console.log(response)
    //         MixHelper.events.errorCatched(e.reason, response.data)
    //     } catch (e) {   
    //         console.log('first error catch', e)
    //     }
    // }
})

const renderWidget = () => {
    render(
        <Provider store={store}>
            <WidgetContainer />
        </Provider>,
        document.getElementById('root'))
}

const renderFallbackInEditor = () => {
    const FallbackContainer = styled.div`
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #1f1f1f;
		color: #efefef;
        flex-direction: column;
        p {
            width: 80%;
            max-width: 660px;
            font-size: 18px;
            margin: 15px 0;
            text-align: center;
            .mail {
                color: #007bff;
                text-decoration: underline;
            }
        }

        .header {
            font-size: 24px;
            font-weight: bold;
        }
    `

    if (Wix.Utils.getViewMode() != 'site') {
        render(

            <FallbackContainer>
                <p className='header'>
                    We apologize for the inconvenience.
                </p>
                <p>
                    Please contact our support team at <span className='mail'>support@light-tech.io</span>
                </p>
                <p>
                    Include details about the error, the steps that led to it, and a screenshot if possible.
                    This will help us resolve the issue more effectively.
                </p>
            </FallbackContainer>

            , document.querySelector('#root'))
    }
}

const reload_js = (src) => {
    // console.log('script[src="' + src + '"]')
    const oldScript = document.querySelector('script[src="' + src + '"]');
    // console.log('oldScript', oldScript)
    if (oldScript) {
        // console.log('oldScript.remove()')
        oldScript.remove()
    }
    const script = document.createElement('script')
    script.src = src
    document.body.appendChild(script)
}

const jqueryRelatedSrcs = [
    'public/lib/lightslider/lightslider.js',
    'public/lib/textillate/jquery.textillate.js',
    'public/lib/textillate/arabic.lettering.js',
    'public/lib/textillate/jquery.fittext.js'
]

let tryCounter = 0

const MAX_ITERATIONS = 50

const onNoLoad = () => {
    const resources = !!window.$ ? {
        jQuery: !!window.$,
        lightSlider: typeof $('#fake-div-for-slider').lightSlider === 'function',
        textillate: typeof $('#fake-div-for-slider').textillate === 'function',
        typeWriter: typeof Typewriter === 'function'
    } : {
        jQuery: false,
        lightSlider: false,
        textillate: false,
        typeWriter: typeof Typewriter === 'function'
    }
    console.log('resources', resources)
    MixHelper.events.resourcesNotLoaded(resources)
    renderFallbackInEditor()
}

const checkAndRender = () => {
    const fakeDiv = document.createElement('div')
    fakeDiv.style.display = 'none'
    fakeDiv.id = 'fake-div-for-slider'
    document.body.appendChild(fakeDiv)

    if (window.$ && typeof Typewriter === 'function' && typeof $('#fake-div-for-slider').lightSlider === 'function' && typeof $('#fake-div-for-slider').textillate === 'function') {
        fakeDiv.remove()
        renderWidget()
    } else {
        console.log('need timeout')
        if (tryCounter > MAX_ITERATIONS) {
            if (!window.$) {
                const script = document.createElement('script')
                script.src = 'public/lib/jquery/jquery.min.js'
                document.body.appendChild(script)
                tryCounter = 0
                let intervalCounter = 0
                const checkJQueryLoad = setInterval(() => {
                    console.log('checkJQueryLoad')
                    if (intervalCounter > MAX_ITERATIONS) {
                        clearInterval(checkJQueryLoad)
                        onNoLoad()
                        fakeDiv.remove()
                        return
                    }
                    if (window.$) {
                        clearInterval(checkJQueryLoad)
                        for (let src of jqueryRelatedSrcs) {
                            reload_js(src)
                        }
                        checkAndRender()
                    }
                    intervalCounter++
                }, 200)
                return
            }

            onNoLoad()
            fakeDiv.remove()
            return
        }
        setTimeout(() => {
            tryCounter++
            fakeDiv.remove()
            checkAndRender()
        }, 100)
    }
}

checkAndRender()
